import { createAsyncThunk } from "@reduxjs/toolkit";
import { EventPayload } from "../common/types/Event";
import { Options } from "../common/types/requestOptions";
import { RootState } from "./store";

export const createQueryAsyncThunk = <
  TResponse, // return type
  TFilter, // filter type
>(
  typePrefix: string,
  queryFn: (filters: TFilter, options: Options) => Promise<TResponse>,
) => {
  return createAsyncThunk<TResponse, TFilter, { state: RootState }>(
    typePrefix,
    async (filters: TFilter, { requestId }) =>
      await queryFn(filters, { requestId }),
  );
};

export const createCommandAsyncThunk = <
  TBody, // body type
  TEvent, // event type
>(
  typePrefix: string,
  commandFn: (body: TBody, options: Options) => Promise<EventPayload<TEvent>[]>,
) => {
  return createAsyncThunk<EventPayload<TEvent>[], TBody, { state: RootState }>(
    typePrefix,
    async (body: TBody, { requestId }) => await commandFn(body, { requestId }),
  );
};

export const createMsgCommandAsyncThunk = <
  TBody, // body type
  TResponse, // response type
>(
  typePrefix: string,
  commandFn: (body: TBody, options: Options) => Promise<TResponse>,
) => {
  return createAsyncThunk<TResponse, TBody, { state: RootState }>(
    typePrefix,
    async (body: TBody, { requestId }) => await commandFn(body, { requestId }),
  );
};
